module.exports = __webpack_public_path__ + "img/add_logo_drack_full.aafdfb60.png";